import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import "../styles/Auth.css";
import {
  FiEdit2, 
} from "react-icons/fi";


export default function AccountSetting() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    name: "",
    password: "",
    address: "",
    city: "",
    country: "",
    postalCode: "",
    phone: "",
    avatarUrl: "",
  });
  const [message, setMessage] = useState("");

  const [orders, setOrders] = useState([]);
  const [filterStatus, setFilterStatus] = useState("All");
  const [expandedOrder, setExpandedOrder] = useState(null);

  const [showProfile, setShowProfile] = useState(true);

  useEffect(() => {
    fetch(`https://biosurgebackend-1.onrender.com/api/userdata/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setUser(data);
        setForm((prev) => ({
          ...prev,
          name: data.name || "",
          address: data.address || "",
          city: data.city || "",
          country: data.country || "",
          postalCode: data.postalCode || "",
          phone: data.phone || "",
          avatarUrl: data.avatarUrl || "",
        }));
      })
      .catch(console.error);
  }, [id]);

 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const updates = { ...form };
    if (!updates.password) delete updates.password;

    fetch(`https://biosurgebackend-1.onrender.com/api/userdata/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updates),
    })
      .then((res) => res.json())
      .then((data) => {
        setUser(data);
        setMessage("Profile updated successfully!");
        setForm((prev) => ({ ...prev, password: "" }));
      })
      .catch((err) => {
        console.error(err);
        setMessage("Update failed");
      });
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const localUrl = URL.createObjectURL(file);
    setForm((prev) => ({ ...prev, avatarUrl: localUrl }));
   
  };

  const handleFilterClick = (status) => {
    setFilterStatus(status);
    setExpandedOrder(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  if (!user) {
    return <p className="loading-text">Loading profile…</p>;
  }

  const filteredOrders = orders.filter((order) => {
    if (filterStatus === "All") return true;
    return order.status === filterStatus;
  });

  const hour = new Date().getHours();
const greet =
  hour < 12 ? "Good Morning 🌞  " :
  hour < 18 ? "Good Afternoon ☕" :
  "Good Evening 🌙";

const firstName = user?.name?.split(" ")[0] || "User";

  return (
    <div className="dashboard-card">
    {/* User Header */}
    <div className="user-header">
      <div className="avatar-wrapper">
        <div className="user-avatar">
          {form.avatarUrl ? (
            <img src={form.avatarUrl} alt="Avatar" className="avatar-image" />
          ) : (
            <span className="avatar-placeholder">
              {user.name ? user.name.charAt(0).toUpperCase() : ""}
            </span>
          )}
        </div>
        <button
          className="edit-avatar-btn"
          onClick={() => document.getElementById("avatar-input").click()}
        >
          <FiEdit2 />
        </button>
        <input
          type="file"
          id="avatar-input"
          hidden
          accept="image/*"
          onChange={handleAvatarChange}
        />
      </div>
      <div className="greeting-logout-wrapper">
        <h2 className="user-greeting">
        {greet} {firstName} 
        </h2>
        <button className="btn-logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>


  </div>
  );
}